var map = {
	"./admin.png": 6808,
	"./body_markers/anatomy.gif": 2784,
	"./body_markers/female.gif": 9241,
	"./body_markers/male.gif": 2870,
	"./celebration.png": 385,
	"./consultMD_logo.png": 5902,
	"./consultderm_logo.png": 4089,
	"./doctor-diagnose-patient-symptoms-hospital 1.png": 5798,
	"./doctor_patient.png": 7382,
	"./doctors.png": 8461,
	"./doctorwriting.png": 6406,
	"./invite.png": 7218,
	"./lock.png": 3172,
	"./main.png": 9082,
	"./missing_patients.png": 6580,
	"./patients.png": 2355,
	"./profile.png": 9062,
	"./specialists.png": 5959,
	"./vault.png": 3305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2672;